//Disable Blank Search
document.addEventListener('submit', function (event) {
  const form = event.target;

  if (form.matches('form[action="/search"]')) {
    const input = form.querySelector('input[name="q"]');

    if (input && input.value.trim() === '') {
      event.preventDefault();
      input.focus();
    }
  }
});